import { User } from '../models';
import { useDocument } from './useDocument';

export function useUser(id: string) {
  return useDocument<User>('Users', id);
}
